import FormattingService from './formattingService';

export const textFormatter = new FormattingService();
